import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, normalizeClass as _normalizeClass, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createBlock as _createBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-1ba924ae"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/_createTextVNode("My projects")
const _hoisted_2 = /*#__PURE__*/_createTextVNode("All projects")
const _hoisted_3 = /*#__PURE__*/_createTextVNode("Add project")
const _hoisted_4 = /*#__PURE__*/_createTextVNode("Summary")
const _hoisted_5 = /*#__PURE__*/_createTextVNode("Sign out")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ion_title = _resolveComponent("ion-title")!
  const _component_ion_toolbar = _resolveComponent("ion-toolbar")!
  const _component_ion_header = _resolveComponent("ion-header")!
  const _component_ion_icon = _resolveComponent("ion-icon")!
  const _component_ion_label = _resolveComponent("ion-label")!
  const _component_ion_item = _resolveComponent("ion-item")!
  const _component_ion_menu_toggle = _resolveComponent("ion-menu-toggle")!
  const _component_ion_list = _resolveComponent("ion-list")!
  const _component_ion_content = _resolveComponent("ion-content")!
  const _component_ion_menu = _resolveComponent("ion-menu")!
  const _component_ion_router_outlet = _resolveComponent("ion-router-outlet")!
  const _component_ion_split_pane = _resolveComponent("ion-split-pane")!
  const _component_ion_app = _resolveComponent("ion-app")!

  return (_openBlock(), _createBlock(_component_ion_app, null, {
    default: _withCtx(() => [
      _createVNode(_component_ion_split_pane, { "content-id": "main-content" }, {
        default: _withCtx(() => [
          (_ctx.isLoggedIn)
            ? (_openBlock(), _createBlock(_component_ion_menu, {
                key: 0,
                "content-id": "main-content",
                type: "overlay",
                ref: "menu"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_ion_header, null, {
                    default: _withCtx(() => [
                      _createVNode(_component_ion_toolbar, null, {
                        default: _withCtx(() => [
                          _createVNode(_component_ion_title, null, {
                            default: _withCtx(() => [
                              _hoisted_1
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_ion_content, null, {
                    default: _withCtx(() => [
                      _createVNode(_component_ion_list, null, {
                        default: _withCtx(() => [
                          _createVNode(_component_ion_menu_toggle, { "auto-hide": "false" }, {
                            default: _withCtx(() => [
                              _createVNode(_component_ion_item, {
                                onClick: _cache[0] || (_cache[0] = ($event: any) => ($data.selectedIndex = 0)),
                                "router-direction": "root",
                                "router-link": "/lists",
                                lines: "none",
                                detail: "false",
                                class: _normalizeClass(["hydrated", { selected: _ctx.$route.name == 'Lists' }])
                              }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_ion_icon, {
                                    slot: "start",
                                    ios: $data.albumsOutline,
                                    md: $data.albumsOutline
                                  }, null, 8, ["ios", "md"]),
                                  _createVNode(_component_ion_label, null, {
                                    default: _withCtx(() => [
                                      _hoisted_2
                                    ]),
                                    _: 1
                                  })
                                ]),
                                _: 1
                              }, 8, ["class"])
                            ]),
                            _: 1
                          }),
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($options.pages, (p, i) => {
                            return (_openBlock(), _createBlock(_component_ion_menu_toggle, {
                              "auto-hide": "false",
                              key: i
                            }, {
                              default: _withCtx(() => [
                                _createVNode(_component_ion_item, {
                                  onClick: ($event: any) => ($data.selectedIndex = i + 1),
                                  "router-direction": "root",
                                  "router-link": p.url,
                                  lines: "none",
                                  detail: "false",
                                  class: _normalizeClass(["hydrated", { selected: _ctx.$route.name == p.title }])
                                }, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_ion_icon, {
                                      slot: "start",
                                      ios: p.iosIcon,
                                      md: p.mdIcon
                                    }, null, 8, ["ios", "md"]),
                                    _createVNode(_component_ion_label, null, {
                                      default: _withCtx(() => [
                                        _createTextVNode(_toDisplayString(p.title), 1)
                                      ]),
                                      _: 2
                                    }, 1024)
                                  ]),
                                  _: 2
                                }, 1032, ["onClick", "router-link", "class"])
                              ]),
                              _: 2
                            }, 1024))
                          }), 128)),
                          _createVNode(_component_ion_item, {
                            lines: "none",
                            class: "add-new",
                            onClick: _cache[1] || (_cache[1] = ($event: any) => ($options.addNew())),
                            disabled: !$data.isConnected
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_ion_icon, {
                                slot: "start",
                                color: "primary",
                                ios: $data.addCircleOutline,
                                md: $data.addCircleOutline
                              }, null, 8, ["ios", "md"]),
                              _createVNode(_component_ion_label, null, {
                                default: _withCtx(() => [
                                  _hoisted_3
                                ]),
                                _: 1
                              })
                            ]),
                            _: 1
                          }, 8, ["disabled"])
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_ion_list, null, {
                        default: _withCtx(() => [
                          _createVNode(_component_ion_menu_toggle, { "auto-hide": "false" }, {
                            default: _withCtx(() => [
                              _createVNode(_component_ion_item, {
                                onClick: _cache[2] || (_cache[2] = ($event: any) => ($data.selectedIndex = 0)),
                                "router-direction": "root",
                                "router-link": "/summary",
                                lines: "none",
                                detail: "false",
                                class: _normalizeClass(["hydrated", { selected: _ctx.$route.name == 'Summary' }])
                              }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_ion_icon, {
                                    slot: "start",
                                    ios: $data.listOutline,
                                    md: $data.listOutline
                                  }, null, 8, ["ios", "md"]),
                                  _createVNode(_component_ion_label, null, {
                                    default: _withCtx(() => [
                                      _hoisted_4
                                    ]),
                                    _: 1
                                  })
                                ]),
                                _: 1
                              }, 8, ["class"])
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_ion_list, null, {
                        default: _withCtx(() => [
                          _createVNode(_component_ion_menu_toggle, { "auto-hide": "false" }, {
                            default: _withCtx(() => [
                              _createVNode(_component_ion_item, {
                                onClick: _cache[3] || (_cache[3] = ($event: any) => ($options.logout())),
                                "router-direction": "root",
                                lines: "none",
                                detail: "false",
                                class: "hydrated",
                                disabled: !$data.isConnected
                              }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_ion_icon, {
                                    slot: "start",
                                    ios: $data.logOutOutline,
                                    md: $data.logOutOutline
                                  }, null, 8, ["ios", "md"]),
                                  _createVNode(_component_ion_label, null, {
                                    default: _withCtx(() => [
                                      _hoisted_5
                                    ]),
                                    _: 1
                                  })
                                ]),
                                _: 1
                              }, 8, ["disabled"])
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }, 512))
            : _createCommentVNode("", true),
          _createVNode(_component_ion_router_outlet, { id: "main-content" })
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}